export default __webpack_public_path__ + "static/media/call-to-action-card2.376f7761.png";